import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
export var Label = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  display: block;\n  font-size: 0.75rem;\n  margin-bottom: 2px;\n  user-select: none;\n"], ["\n  color: ",
    ";\n  display: block;\n  font-size: 0.75rem;\n  margin-bottom: 2px;\n  user-select: none;\n"])), function (_a) {
    var error = _a.error, theme = _a.theme;
    return error ? theme.colors.error : theme.colors.text.primary;
});
var templateObject_1;
